import { render, staticRenderFns } from "./userSearch.vue?vue&type=template&id=0ce38042&scoped=true"
import script from "./userSearch.vue?vue&type=script&lang=js"
export * from "./userSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce38042",
  null
  
)

export default component.exports